import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "./NftList.scss";
import Api from "../../Common/api.jsx";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import NFTMarket from "../../../artifacts/contracts/NFTMarket.sol/NFTMarket.json";
import { notifications } from "../../Helpers/Notifications";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorHandler from "../../Helpers/ErrorHandler.jsx";
import CommonHelper from "../../Helpers/CommonHelper.jsx";
import { Navigate } from "react-router-dom";

export default class NftList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      assetDetails: {},
      id: null,
      navigateTo: "",
      isNavigate: false,
      openPopup: false,
      waitingForApproval: false,
      isOrderCompleted: false,
      price: null,
      formErrors: { price: "" },
      priceValid: false,
      formValid: false,
      chainConfig: null,
      showSwitchNetworkPopup: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // window.addEventListener('click', () => {document.getElementsByClassName("search-autocomplete")[0].style.display="none" });
    const search = window.location.search;
    const params = new URLSearchParams(search);

    this.setState(
      {
        id: params.get("asset_id"),
      },
      () => {
        this.getAsset();
      }
    );
  }

  togglePopup(value) {
    this.setState({ openPopup: value });
  }

  getAsset() {
    const api = new Api();
    api
      .get("get_asset/?asset_id=" + this.state.id, {})
      .then((response) => {
        const chainConfig = new CommonHelper().getChainConfig(
          response.data.chain_id
        );
        this.setState({
          assetDetails: response.data,
          chainConfig: chainConfig,
        });
        //this.getMarketItem();
        //console.log("assetDetails", response.data);
      })
      .catch((err) => console.log(err));
  }

  async getMarketItem() {
    var contract = await this.getContract();
    return await contract.getMarketItemByTokenId(
      parseInt(this.state.assetDetails.token_id)
    );
  }

  async listItem() {
    //validate first
    this.validateField("price", this.state.price);
    if (!this.state.formValid) {
      return;
    }

    if (window.ethereum.networkVersion != this.state.chainConfig.CHAIN_ID) {
      this.setState({ showSwitchNetworkPopup: true });

      return;
    }

    try {
      this.setState({ waitingForApproval: true });

      if (this.state.assetDetails.status === "Minted") {
        await this.createMarketItem();
      } else {
        await this.resellMarketItem();
      }
    } catch (err) {
      notifications.error("Something went wrong.");
      this.setState({ waitingForApproval: false });
    }
  }

  async createMarketItem() {
    {
      var contract = await this.getContract();
      const price = ethers.utils.parseUnits(this.state.price, "ether");
      let listingPrice = await contract.getListingPrice();

      await contract
        .createMarketItem(this.state.assetDetails.token_id, price, {
          value: listingPrice,
        })
        .then(
          async (transactionDetails) => {
            var tx = await transactionDetails.wait();
            var asset_activity = {
              from_account: tx.from,
              to_account: tx.to,
              price: this.state.price,
              asset_id: this.state.assetDetails.asset_id,
              currency: this.state.chainConfig.CURRENCY_SYMBOL,
              activity_type_id: 2,
              transaction_hash: tx.transactionHash,
            };
            await new Api().post("create_activity/", asset_activity);
            this.setState({ openPopup: true });
            notifications.success("Item listed successfully");

            setTimeout(() => {
              this.setState({
                navigateTo:
                  "/nftDetails/?assetId=" + this.state.assetDetails.asset_id,
                isNavigate: true,
              });
            }, 1000);
          },

          (err) => {
            new ErrorHandler().processEtherMessage(err);
            const timer = setTimeout(() => {
              this.setState({ waitingForApproval: false });
            }, 1000);
          }
        );
    }
  }

  async resellMarketItem() {
    {
      var contract = await this.getContract();
      const price = ethers.utils.parseUnits(this.state.price, "ether");
      let listingPrice = await contract.getListingPrice();

      await contract
        .resellToken(this.state.assetDetails.token_id, price, {
          value: listingPrice,
        })
        .then(
          async (transactionDetails) => {
            var tx = await transactionDetails.wait();
            var asset_activity = {
              from_account: tx.from,
              to_account: tx.to,
              price: this.state.price,
              asset_id: this.state.assetDetails.asset_id,
              currency: this.state.chainConfig.CURRENCY_SYMBOL,
              activity_type_id: 2,
              transaction_hash: tx.transactionHash,
            };
            await new Api().post("create_activity/", asset_activity);
            this.setState({ openPopup: true });
            notifications.success("Item listed successfully");

            setTimeout(() => {
              this.setState({
                navigateTo:
                  "/nftDetails/?assetId=" + this.state.assetDetails.asset_id,
                isNavigate: true,
              });
            }, 1000);
          },

          (err) => {
            new ErrorHandler().processEtherMessage(err);
            const timer = setTimeout(() => {
              this.setState({ waitingForApproval: false });
            }, 1000);
          }
        );
    }
  }

  handleUserInput(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }

  validateField(fieldName, value) {
    let fieldValidationErrors = this.state.formErrors;
    let priceValid = this.state.priceValid;

    switch (fieldName) {
      case "price":
        priceValid = value ? true : false;
        fieldValidationErrors.price = priceValid ? "" : "Price is required";
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        priceValid: priceValid,
      },
      this.validateForm
    );
  }

  validateForm() {
    this.setState({
      formValid: this.state.priceValid,
    });
  }

  async getContract() {
    const web3Modal = new Web3Modal();
    const connection = await web3Modal.connect();
    const provider = new ethers.providers.Web3Provider(connection);
    const signer = provider.getSigner();
    const contract = new ethers.Contract(
      this.state.chainConfig.NFT_MARKETPLACE_ADDRESS,
      NFTMarket.abi,
      signer
    );

    return contract;
  }

  render = () => {
    if (this.state.isNavigate) {
      return <Navigate to={this.state.navigateTo} />;
    }
    return (
      <>
        <Header
          showSwitchNetworkPopup={this.state.showSwitchNetworkPopup}
          network={this.state.chainConfig?.NETWORK_NAME}
          chainId={this.state.chainConfig?.CHAIN_HEX_ID}
          onPopupClose={() => {
            this.setState({ showSwitchNetworkPopup: false });
          }}
        />

        <ToastContainer pauseOnFocusLoss draggable pauseOnHover />
        <div className="exploreCollections nft-list-page">
          <div className="container">
            <div className="section-title">
              <h2>List item for sale</h2>
            </div>
            <div className="nft-list-page__left">
              <div className="nft-list-page__img">
                <img
                  src={this.state.assetDetails.asset_image}
                  alt="profileimage"
                />
              </div>
              <div className="nft-list-page__info-bid">
                <h3>{this.state.assetDetails.asset_name}</h3>
                {/* <a href="/" className="btn-preview">
                  <i className="material-icons-outlined">visibility_outlined</i>{" "}
                  Preview
                </a> */}
                <span>Untitled Collection</span>
                <div className="price">
                  <img src="../images/eth.png" alt="eth" />
                  {this.state.assetDetails.price ?? 0}
                </div>
              </div>
            </div>
            <div className="nft-list-page__right">
              <div className="sign-up__form">
                {/* <div className="form-group">
                  <label>Type</label>
                  <div className="select-dd">
                    <select>
                      <option value="item1">Fixed Price</option>
                    </select>
                  </div>
                </div> */}
                <div className="form-group">
                  <label>Price *</label>
                  <div className="form-control__wrapp">
                    <img
                      className="priceIcon"
                      src="../images/eth.png"
                      alt="Coin"
                    />
                    <input
                      disabled={this.state.waitingForApproval}
                      name="price"
                      type="text"
                      className="form-control"
                      placeholder="e.g : 0.0001"
                      value={this.state.price}
                      onChange={(event) => this.handleUserInput(event)}
                    />
                  </div>
                  <p className="error">{this.state.formErrors?.price}</p>
                </div>

                <div className="form-group">
                  <h5>Service Fee: 2.5%</h5>
                </div>
                <div className="form-group__btn">
                  {this.state.waitingForApproval ? (
                    <div className="button btn-waiting ">
                      <img
                        className="loader"
                        src="../Loader/redshilliz-loader.gif "
                        alt="Coin"
                      />
                      Waiting for approval ...
                    </div>
                  ) : (
                    <button className="button" onClick={() => this.listItem()}>
                      Complete Listing
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  };
}
